<template>
   <div class="type-list-container">
      <div class="label">Types</div>
      <ul class="metric-types">
         <li v-for="(type, index) in typeList" :key="index" :class="typeListClass(type, selectedTypes)" v-on:click="changeMetricType(type)">{{formatTypeName(type)}}</li>
      </ul>
   </div>
</template>

<script>
export default {
   name: "ListMetricTypes",
   props: ["typeList","selectedTypes","chartIndex"],
   methods: {
      changeMetricType: function(type) {
         this.$emit("changeType", {"chartIndex": this.chartIndex, "type":type});
      },
      typeListClass: function(type, types) {
         let classes = ["metric-type",type];
         if(types.includes(type)) classes.push('active');
         return classes;
      },
      formatTypeName: function(type) {
         return type.charAt(0).toUpperCase() + type.slice(1);
      }
   }
}
</script>

<style lang="scss">
.type-list-container {
   .label { font-weight: bold; text-transform: uppercase; color: #000; margin-top: 0.5em; text-align: left; display: block;}
   &:after {
      content: "";
      display: table;
      clear: both;
   }
}
.metric-types {
   list-style: none;
   /*text-align: center;*/
   width: 100%;
   padding-left: 0;
   margin-top: 0.5em;
   .metric-type {
      margin-right: 10px;
      width: 125px;
      line-height: 30px;
      margin-bottom: 5px;
      color:#000;
      cursor: pointer;
      &.files { background-color: #ada397; }
      &.volume { background-color: #bdcebe; }
      &.visitors { background-color: #d6cbd3; }
      &.active {
         color:#fff;
         font-weight: bold;
      }
   }
}

@media screen and (min-width: 1200px) {
   .type-list-container {
      display: block;
   }
   .metric-types {
      margin-bottom: 0;
      li { /*display: inline-block;*/ float: left; }
   }
}
</style>